/**
 * Single source of truth for environments allowed to write missing i18n keys.
 *
 * Add new production/deploy environments here intentionally so both i18n.ts
 * and locize.js stay in sync.
 */
export const LOCIZE_SAVE_MISSING_ENV_ALLOWLIST = [
  'dev',
  'prod',
  'prodeu1',
  'prodcan1',
  'prodaus1',
];

export const shouldSaveMissingToProduction = (
  environment?: string,
): boolean => {
  const normalizedEnvironment = (environment || '').toLowerCase();

  if (!normalizedEnvironment) {
    return false;
  }

  return LOCIZE_SAVE_MISSING_ENV_ALLOWLIST.includes(normalizedEnvironment);
};
